__turbopack_context__.v({
  "aboutCard": "AboutSection-module-scss-module__0dRRvq__aboutCard",
  "aboutCardContent": "AboutSection-module-scss-module__0dRRvq__aboutCardContent",
  "aboutCardVisual": "AboutSection-module-scss-module__0dRRvq__aboutCardVisual",
  "aboutCards": "AboutSection-module-scss-module__0dRRvq__aboutCards",
  "aboutDescription": "AboutSection-module-scss-module__0dRRvq__aboutDescription",
  "aboutSection": "AboutSection-module-scss-module__0dRRvq__aboutSection",
  "aboutTitle": "AboutSection-module-scss-module__0dRRvq__aboutTitle",
  "codeCursor": "AboutSection-module-scss-module__0dRRvq__codeCursor",
  "codeLine": "AboutSection-module-scss-module__0dRRvq__codeLine",
  "codeWave": "AboutSection-module-scss-module__0dRRvq__codeWave",
  "cursorBlink": "AboutSection-module-scss-module__0dRRvq__cursorBlink",
  "designVisual": "AboutSection-module-scss-module__0dRRvq__designVisual",
  "deviceDot": "AboutSection-module-scss-module__0dRRvq__deviceDot",
  "deviceLaptop": "AboutSection-module-scss-module__0dRRvq__deviceLaptop",
  "devicePhone": "AboutSection-module-scss-module__0dRRvq__devicePhone",
  "deviceTablet": "AboutSection-module-scss-module__0dRRvq__deviceTablet",
  "floatY": "AboutSection-module-scss-module__0dRRvq__floatY",
  "frontendVisual": "AboutSection-module-scss-module__0dRRvq__frontendVisual",
  "mobileVisual": "AboutSection-module-scss-module__0dRRvq__mobileVisual",
  "orbit": "AboutSection-module-scss-module__0dRRvq__orbit",
  "pulseRing": "AboutSection-module-scss-module__0dRRvq__pulseRing",
  "uiPulse": "AboutSection-module-scss-module__0dRRvq__uiPulse",
  "uiShape": "AboutSection-module-scss-module__0dRRvq__uiShape",
});
